var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"plugin-about-media-item swiper-slide",attrs:{"href":_vm.url,"target":"_blank"}},[_c('div',{staticClass:"plugin-about-media-item__image swiper-lazy",attrs:{"data-background":_vm.resizedImage}}),_c('div',{staticClass:"plugin-about-media-item__loader"},[_c('ui-loader',{attrs:{"fixed":50,"centered":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }